import { render, staticRenderFns } from "./registro.vue?vue&type=template&id=b9082bf4&scoped=true"
import script from "./registro.vue?vue&type=script&lang=js"
export * from "./registro.vue?vue&type=script&lang=js"
import style0 from "./registro.vue?vue&type=style&index=0&id=b9082bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9082bf4",
  null
  
)

export default component.exports